module.exports = "/images/vendor/flag-icon-css/flags/4x3/aq.svg?65afe1f1ffb9d9a23d25d2327ba2c3d3";